import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import './App.css';

import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import YeteneklerPage from './pages/YeteneklerPage';
import KurumsalPage from './pages/KurumsalPage';
import IletisimPage from './pages/IletisimPage';

export default function App() {
  return (
    <BrowserRouter>
      <Header />
      <main style={{ minHeight: '100vh' }}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/yetenekler" element={<YeteneklerPage />} />
          <Route path="/kurumsal" element={<KurumsalPage />} />
          <Route path="/iletisim" element={<IletisimPage />} />
          {/* Fallback */}
          <Route path="*" element={<HomePage />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}
